import { Product, Offer, Order, User, Address } from '@/types';

export const mockProducts: Product[] = [
  {
    id: '1',
    name: 'Blue Cotton Shirt',
    brand: 'Allen Solley',
    price: 560,
    originalPrice: 700,
    discount: 20,
    rating: 4.5,
    reviewCount: 128,
    image: 'https://images.unsplash.com/photo-1596755094514-f87e34085b2c?w=400&h=500&fit=crop',
    category: 'ladies',
    subcategory: 'Shirts',
    color: 'Red',
    sizes: ['S', 'M', 'L', 'XL'],
    isNew: true,
    stock: 25
  },
  {
    id: '2',
    name: 'Kurtis Black',
    brand: 'Joyaura',
    price: 400,
    originalPrice: 500,
    discount: 20,
    rating: 5.0,
    reviewCount: 1,
    image: 'https://images.unsplash.com/photo-1583391733956-6c78276477e2?w=400&h=500&fit=crop',
    category: 'ladies',
    subcategory: 'Kurtis',
    color: 'Black',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    isNew: true,
    stock: 42
  },
  {
    id: '3',
    name: 'Bridal Red Saree',
    brand: 'Kanjivaram Weavers',
    price: 3240,
    originalPrice: 4000,
    discount: 19,
    rating: 4.7,
    reviewCount: 89,
    image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=400&h=500&fit=crop',
    category: 'ladies',
    subcategory: 'Sarees',
    color: 'Red',
    sizes: ['Free Size'],
    isNew: true,
    stock: 12
  },
  {
    id: '4',
    name: 'Midnight Blue Suit',
    brand: 'Raymond',
    price: 8500,
    originalPrice: 10000,
    discount: 15,
    rating: 4.8,
    reviewCount: 56,
    image: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=400&h=500&fit=crop',
    category: 'men',
    subcategory: 'Suits',
    color: 'Blue',
    sizes: ['38', '40', '42', '44'],
    isNew: true,
    stock: 8
  },
  {
    id: '5',
    name: 'Casual Olive Jacket',
    brand: 'Levi\'s',
    price: 2400,
    originalPrice: 3000,
    discount: 20,
    rating: 4.6,
    reviewCount: 234,
    image: 'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=400&h=500&fit=crop',
    category: 'men',
    subcategory: 'Jackets',
    color: 'Olive',
    sizes: ['S', 'M', 'L', 'XL'],
    stock: 35
  },
  {
    id: '6',
    name: 'Bomber Jacket',
    brand: 'Zara Kids',
    price: 1200,
    originalPrice: 1500,
    discount: 20,
    rating: 4.3,
    reviewCount: 67,
    image: 'https://images.unsplash.com/photo-1519238263530-99bdd11df2ea?w=400&h=500&fit=crop',
    category: 'boys',
    subcategory: 'Jackets',
    color: 'Black',
    sizes: ['4-5Y', '6-7Y', '8-9Y', '10-11Y'],
    isNew: true,
    stock: 28
  },
  {
    id: '7',
    name: 'Ethnic Kurta Set',
    brand: 'FabIndia',
    price: 1800,
    originalPrice: 2000,
    discount: 10,
    rating: 4.4,
    reviewCount: 45,
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=500&fit=crop',
    category: 'boys',
    subcategory: 'Ethnic',
    color: 'Yellow',
    sizes: ['4-5Y', '6-7Y', '8-9Y', '10-11Y', '12-13Y'],
    stock: 19
  },
  {
    id: '8',
    name: 'Floral Summer Dress',
    brand: 'H&M Kids',
    price: 899,
    originalPrice: 1199,
    discount: 25,
    rating: 4.5,
    reviewCount: 112,
    image: 'https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=400&h=500&fit=crop',
    category: 'girls',
    subcategory: 'Dresses',
    color: 'Pink',
    sizes: ['3-4Y', '5-6Y', '7-8Y', '9-10Y'],
    isNew: true,
    stock: 45
  },
  {
    id: '9',
    name: 'Denim Skirt',
    brand: 'Gap Kids',
    price: 1100,
    originalPrice: 1400,
    discount: 21,
    rating: 4.2,
    reviewCount: 78,
    image: 'https://images.unsplash.com/photo-1503449377594-32dd9ac4467c?w=400&h=500&fit=crop',
    category: 'girls',
    subcategory: 'Skirts',
    color: 'Blue',
    sizes: ['4-5Y', '6-7Y', '8-9Y', '10-11Y'],
    stock: 32
  },
  {
    id: '10',
    name: 'Slim Fit Jeans',
    brand: 'Levi\'s',
    price: 1800,
    originalPrice: 2200,
    discount: 18,
    rating: 4.6,
    reviewCount: 189,
    image: 'https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&h=500&fit=crop',
    category: 'men',
    subcategory: 'Jeans',
    color: 'Blue',
    sizes: ['30', '32', '34', '36', '38'],
    stock: 67
  },
  {
    id: '11',
    name: 'Polo T-Shirt',
    brand: 'US Polo',
    price: 799,
    originalPrice: 999,
    discount: 20,
    rating: 4.4,
    reviewCount: 245,
    image: 'https://images.unsplash.com/photo-1625910513413-5fc45e1c9f70?w=400&h=500&fit=crop',
    category: 'men',
    subcategory: 'T-Shirts',
    color: 'Navy',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    isNew: true,
    stock: 89
  },
  {
    id: '12',
    name: 'Anarkali Suit',
    brand: 'Biba',
    price: 2499,
    originalPrice: 3199,
    discount: 22,
    rating: 4.7,
    reviewCount: 156,
    image: 'https://images.unsplash.com/photo-1617137968427-85924c800a22?w=400&h=500&fit=crop',
    category: 'ladies',
    subcategory: 'Suits',
    color: 'Maroon',
    sizes: ['S', 'M', 'L', 'XL'],
    stock: 23
  }
];

export const mockOffers: Offer[] = [
  {
    id: '1',
    title: 'FLAT 50% OFF',
    description: 'On all ethnic wear this festive season',
    code: 'FESTIVE50',
    image: 'https://images.unsplash.com/photo-1607083206869-4c7672e72a8a?w=800&h=300&fit=crop',
    link: '/category/ladies?subcategory=ethnic'
  },
  {
    id: '2',
    title: 'Buy 2 Get 1 Free',
    description: 'On kids clothing collection',
    image: 'https://images.unsplash.com/photo-1503449377594-32dd9ac4467c?w=800&h=300&fit=crop',
    link: '/category/kids'
  },
  {
    id: '3',
    title: 'New Arrivals',
    description: 'Check out the latest winter collection',
    image: 'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=800&h=300&fit=crop',
    link: '/new-arrivals'
  },
  {
    id: '4',
    title: 'Free Shipping',
    description: 'On orders above ₹999',
    image: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=800&h=300&fit=crop',
    link: '/offers'
  }
];

export const mockAddress: Address = {
  id: '1',
  name: 'Srihari Papisetti',
  line1: '1B, Anna Street',
  line2: 'Ram Nagar',
  city: 'Ambattur',
  state: 'Tamil Nadu',
  pincode: '600053',
  phone: '+91 98765 43210'
};

export const mockUser: User = {
  id: '1',
  name: 'Srihari Papisetti',
  email: 'srihari@example.com',
  phone: '+91 98765 43210',
  addresses: [mockAddress]
};

export const mockOrders: Order[] = [
  {
    id: 'ORD-2024-001',
    date: '2024-12-15',
    status: 'delivered',
    items: [
      {
        ...mockProducts[0],
        quantity: 1,
        selectedSize: 'M'
      }
    ],
    total: 560,
    deliveryAddress: mockAddress,
    paymentMethod: 'online'
  },
  {
    id: 'ORD-2024-002',
    date: '2024-12-18',
    status: 'shipped',
    items: [
      {
        ...mockProducts[1],
        quantity: 2,
        selectedSize: 'L'
      },
      {
        ...mockProducts[4],
        quantity: 1,
        selectedSize: 'M'
      }
    ],
    total: 3200,
    deliveryAddress: mockAddress,
    paymentMethod: 'cod'
  }
];
